module.exports = "<h2 class=\"hs-title\">{{title}}</h2>\r\n<div class=\"alert alert-{{color}}\">\r\n    <strong>{{subtitle}}</strong> {{message}}\r\n</div>\r\n"